<template>
  <div class="d-flex flex-column justify-center align-center" style="height: 100%">
    <div style="width: 200px; height: 200px">
      <animal-poly></animal-poly>
    </div>
    <div>모델을 불러오는 중...</div>
  </div>
</template>

<script>
import AnimalPoly from "@/components/AnimalPoly.vue";
import LegacyApi from "../../../api/LegacyApi";
import InMemoryStorage from "../../../domain/storage/InMemoryStorage";
import delay from "@/utils/delay";
import SupabaseApi from "@/api/SupabaseApi";

export default {
  components: { AnimalPoly },
  async created() {
    try {
      const result = await Promise.all([delay(1000), this.reload()]);
      await delay(500);
      const meta = InMemoryStorage.get("meta/me");
      if (Object.keys(meta).length === 0) throw new Error("E_INVALID_MODEL");

      // 시작하자마자 로그아웃을 하면 모델로딩에 실패했습니다가 나온다.
      // 시작하자마자 모델이 로딩 되고 완료되기전에 settings 페이지에 진입하면 .back()으로 인해 settings로 가게된다
      // FIX: 모델을 로딩하는 중에는 다른 페이지로 가는걸 막아야 한다
      // 이런것 때문에 미리 로딩페이지를 설계해야한다 Login -> Loading Page -> Home
      // this.$router.back(); // 최초 진입시 버그 있음...
      this.$router.push("/home");
    } catch (error) {
      console.error(error);

      InMemoryStorage.set("meta/me", null);
      InMemoryStorage.set("model/me", null);
      this.$notify({
        title: "모델로딩이 실패했습니다",
        text: "문제가 지속되면 virtupet.official@gmail.com로 문의해주세요",
        type: "error",
        duration: 1500,
      });
      await delay(2000);
      this.$router.push("/home"); // TODO: 로딩 실패 페이지로 이동
    }
  },
  destroyed() {},

  methods: {
    async reload() {
      // const user = InMemoryStorage.get("me/profile") || {};
      // const { modelIndex } = user;
      const modelIndex = await SupabaseApi.PetProfile.fetchModelIndex();
      this.$store.commit("__setCurrentModelIndex", modelIndex);

      const meta = await LegacyApi.fetchMyModelMetadata(modelIndex);
      InMemoryStorage.set("meta/me", JSON.stringify(meta)); // model meta. camera position

      const gltf = await LegacyApi.fetchModel(meta.modelUrl);
      InMemoryStorage.set("model/me", JSON.stringify(gltf)); // model json file
      InMemoryStorage.set(`model/${modelIndex}`, JSON.stringify(gltf)); // model json file
    },
  },
};
</script>

<style></style>
